import { Chip, Stack } from "@mui/material";

import type { WearableViewMode } from "./wearableMetricAggregation";

const VIEW_MODES: Array<{ value: WearableViewMode; label: string }> = [
  { value: "fitness", label: "Google Health" },
  { value: "sleep", label: "Dados do sono" },
];

interface WearableViewModeToggleProps {
  mode: WearableViewMode;
  onChange: (mode: WearableViewMode) => void;
  disabled?: boolean;
}

/** Seletor de modo: métricas do modal fitness vs dados FluxHealth (sono). */
export function WearableViewModeToggle({
  mode,
  onChange,
  disabled = false,
}: WearableViewModeToggleProps) {
  return (
    <Stack
      direction="row"
      spacing={0.75}
      flexWrap="wrap"
      useFlexGap
      sx={{ width: "100%" }}
    >
      {VIEW_MODES.map((item) => {
        const isSelected = mode === item.value;
        return (
          <Chip
            key={item.value}
            label={item.label}
            clickable={!disabled}
            disabled={disabled}
            onClick={() => {
              if (!disabled && item.value !== mode) onChange(item.value);
            }}
            variant={isSelected ? "filled" : "outlined"}
            color={isSelected ? "primary" : "default"}
            sx={{
              fontWeight: isSelected ? 700 : 500,
              fontSize: "0.8rem",
              height: 32,
              borderRadius: 2,
              ...(isSelected && {
                bgcolor: "primary800.main",
                color: "white",
                "&:hover": { bgcolor: "primary900.main" },
              }),
            }}
          />
        );
      })}
    </Stack>
  );
}
